<template>
  <div>
    <h1>404</h1>
  </div>
</template>

<script>

export default {
  mounted () {
    setTimeout(() => {
      this.backHome(true)
    }, 3000)
    throw new Error('notFund')
  }
}
</script>